(function () {
  const initForm = (form) => {
    if (form.dataset.ahmAddToCartInit === "true") return;
    form.dataset.ahmAddToCartInit = "true";

    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) variantInput.disabled = false;

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      const submitButton = form.querySelector('[type="submit"][name="add"]');
      if (!submitButton || submitButton.disabled || submitButton.getAttribute("aria-disabled") === "true") {
        return;
      }

      const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");

      submitButton.setAttribute("aria-disabled", "true");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(form);
      if (cart?.getSectionsToRender) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id).join(",")
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }
      config.body = formData;

      fetch(window.routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "ahm-add-to-cart",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message,
            });
            window.alert(response.description || window.cartStrings?.error || "Could not add to cart.");
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "ahm-add-to-cart",
            productVariantId: formData.get("id"),
            cartData: response,
          });

          if (cart.classList?.contains("is-empty")) {
            cart.classList.remove("is-empty");
          }

          cart.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          if (!submitButton.hasAttribute("disabled")) {
            submitButton.removeAttribute("aria-disabled");
          }
        });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("form[data-ahm-add-to-cart]").forEach(initForm);
  };

  const watchDynamicSections = () => {
    document.querySelectorAll("product-recommendations").forEach((root) => {
      if (root.dataset.ahmAddToCartWatch === "true") return;
      root.dataset.ahmAddToCartWatch = "true";
      new MutationObserver(() => initAll(root)).observe(root, { childList: true, subtree: true });
    });
  };

  const boot = () => {
    initAll();
    watchDynamicSections();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
    watchDynamicSections();
  });
})();
